<template>
<div>
    <el-row type="flex">
        <el-col :span="12" class="card card-dashboard-thirteen mg-b-20 mg-r-20" style="height:100px" v-loading='loading'>
            <h6 class="card-title" style="font-size: 20px;">{{currentfarmats.splitCurrent(currentfarmats.AUformat(total_fund_value))[0]}}<small>{{currentfarmats.splitCurrent(currentfarmats.AUformat(total_fund_value))[1]}}</small></h6>
            <span class="d-block mg-b-20 az-content-text">Total Fund Value</span>
        </el-col>
        <el-col :span="12" class="card card-dashboard-thirteen mg-b-20" style="height:100px" v-loading='loading'>
             <h6 class="card-title" style="font-size: 20px;">{{funds.length}}</h6>
            <span class="d-block mg-b-20 az-content-text">Total Number of Funds</span>
        </el-col>
    </el-row>
    <el-row>
        <div class="card card-table-two" style="height:340px" v-loading='loading'>
            <div class='media'>
            <div class='media-body'>
                <h6 class="card-title" style="font-size: 15px;">SMSF</h6>
            </div>
            <div class='media-body'>
                <el-input 
                style='margin-bottom:5px'
                size='mini'
                v-model="message" 
                prefix-icon="el-icon-search"
                placeholder="Search">
                </el-input>
            </div>
            </div>
            <span class="d-block mg-b-20 az-content-text">Click the fund name to see fund details.</span>
            <div class="table-responsive">
                <table class="table table-striped table-dashboard-two">
                <thead>
                    <tr>
                    <th class="wd-lg-50p">Fund Name</th>
                    </tr>
                </thead>
                <tbody >
                <tr v-for="(item,index) in funds" :key="index">
                    <td class="tx-medium" v-show="item.fund_name.toLowerCase().match(message.toLowerCase())">
                    <router-link :to="{path:'/funddashboard/'+item.fund_code,query:{name:item.fund_name}}">{{item.fund_name}} <i class='fa fa-angle-right'></i></router-link>
                    </td>
                </tr>
                </tbody>
                </table>
            </div><!-- table-responsive -->
        </div><!-- card-dashboard-five -->
    </el-row>
</div>
</template>
<script>
import currentfarmats from '../../../utils/currentformats'
export default {
  name: 'basicinfo',
  components: { 
  },
  props: {
    
  },
  data(){
    return{
      currentfarmats:currentfarmats,
      message:'',
      total_fund_value:'',
      funds:[],
      isChartShow:false,
      loading:true,
    }
  },
  
  beforeCreate(){
    
  },
  created(){
    this.getBasic();
  },
  methods:{
    getBasic: function(){
        let userdetail = JSON.parse(localStorage.getItem('userdetail'));
        this.brands = userdetail['brand_list'];
        this.$api.bo_api.basic_info(this.brands[0][0]).then(response =>{
            this.total_fund_value = response.data['total_fund_value']
            this.funds = response.data['funds']
            this.loading=false
        })
    },
    
  }
}
</script>